"use client";
import { useEffect, useState } from "react";
import { motion } from "framer-motion";

interface Particle {
  id: number;
  startX: number;
  endX: number;
  startY: number;
  endY: number;
  size: number;
  duration: number;
  delay: number;
}

export default function WindParticles() {
  const [particles, setParticles] = useState<Particle[]>([]);

  useEffect(() => {
    // Generate random particles
    const particleCount = 40;
    const newParticles = Array.from({ length: particleCount }).map((_, i) => ({
      id: i,
      startX: -10 - Math.random() * 20, // Start slightly offscreen to the left
      endX: 100 + Math.random() * 20, // End offscreen to the right
      startY: Math.random() * 100, // Random height
      endY: Math.random() * 100 - 30, // Drift upwards slightly
      size: Math.random() * 4 + 2, // size 2px to 6px
      duration: Math.random() * 15 + 10, // animation duration 10s to 25s
      delay: Math.random() * 10, // random start delay
    }));
    setParticles(newParticles);
  }, []);

  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none z-0">
      {particles.map((p) => (
        <motion.div
          key={p.id}
          className="absolute rounded-full bg-accent opacity-50 shadow-[0_0_8px_2px_rgba(222,204,164,0.6)]"
          style={{
            width: p.size,
            height: p.size,
            filter: "blur(1px)",
            top: 0,
            left: 0,
          }}
          animate={{
            x: [`${p.startX}vw`, `${p.endX}vw`],
            y: [`${p.startY}vh`, `${p.endY}vh`],
            opacity: [0, 0.8, 0],
          }}
          transition={{
            duration: p.duration,
            ease: "linear",
            repeat: Infinity,
            delay: p.delay,
          }}
        />
      ))}
    </div>
  );
}